<template>
  <div>
    <div class="addfriend_top_bar">
      <span class="addfriend_tip addfriend_tip_noac" @click="goTome"
        >个人中心</span
      >
      <i class="el-icon-arrow-right"></i>
      <span class="addfriend_tip addfriend_tip_noac" @click="friends"
        >我的好友</span
      >
      <i class="el-icon-arrow-right"></i>
      <span class="addfriend_tip" @click="addfriend">添加好友</span>
    </div>

    <div class="friends_sear" style="margin-top: 30px">
      <div class="friends_sear_con">
        <div class="friend_add_in_con">
          <i class="el-icon-search"></i>
          <input
            class="friend_add_in"
            placeholder="请输入用户名或手机号搜索"
            v-model="searchText"
            v-on:keyup.enter="selectUser"
          />
        </div>
        <el-button @click="selectUser"> 搜索 </el-button>
      </div>
    </div>
    <el-table :data="friList" height="70vh">
      <el-table-column prop="userName" label="用户名"></el-table-column>
      <el-table-column prop="phone" label="手机号"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="primary" plain @click="addFriend(scope.row.userId)"
            >添加</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { selectByKeyword, requestFriendship } from "@/api/friend";
export default {
  name: "addfriend",
  data() {
    return {
      friList: [],
      searchText: "", // 输入框的值
    };
  },
  mounted() {
    this.selectUser();
  },
  methods: {
    addfriend() {
      var that = this;
      that.$router.push({ name: "addfriend", params: { refresh: true } });
    },
    friends() {
      var that = this;

      that.$router.push({ name: "friends", params: { refresh: true } });
    },
    goTome() {
      this.$router.push({ name: "me" });
    },
    addFriend(userId) {
      // 现在这个方法接收 userId 参数
      requestFriendship({ buid: userId })
        .then((response) => {
          console.log(response);
          window.alert("添加请求已经发送");
        })
        .catch((error) => {
          console.error("Error adding friend:", error);
        });
    },
    selectUser() {
      const loading = this.$loading({
        lock: true,
        text: "正在加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)",
        target: ".mymsg_con",
      });
      var that = this;
      const searchTerm = this.searchText;
      selectByKeyword({ key: searchTerm })
        .then((response) => {
          console.log(response);
          var array = response.data;
          if (array.length > 0) {
            that.friList = array;
          } else {
            window.alert("没有查询到该用户");
          }
        })
        .catch((error) => {
          console.error("Error add friend :", error);
        })
        .finally(() => {
          loading.close();
        });
    },
  },
};
</script>

<style>
.friend_add_in {
  margin-left: 5px;
  background: none;
  font-size: 18px;
  border: none;
  outline: none;
}

.friend_add_in_con {
  display: flex;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  border: solid 2px #0187ea;
  background-color: #edf7f9;
  width: 450px;
  margin-right: 16px;
}
.friends_sear_con {
  display: flex;
  align-items: center;
}

.friends_sear {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.addfriend_tip_noac {
  color: #707070 !important;
}

.addfriend_tip {
  font-size: 18px;
  color: #2683be;
  cursor: pointer;
}

.addfriend_top_bar {
  display: flex;
  align-items: center;
}
</style>
